/// <reference path="flow.routes.ts" />
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LunaCommonModule } from "../common/common.module";
import { FormControlsModule } from '../form-controls/form-controls.module';
import { FlowComponent } from './components/flow/flow.component';
import { WorkflowResolver } from "./resolvers/workflow.resolver";
import { FlowInstanceService } from './services/flow-instance.service';
import { FlowHistoryService } from "./services/flow-history.service";
import { Mapper } from './services/mapper.service';
import { OnBehalfMapperService } from "./services/onbehalf-mapper.service";
import { RuleCompiler, FunctionsFactory } from "./services/rule-compiler.service";
import { FlowSectionsComponent } from './components/flow-sections/flow-sections.component';
import { InstantiateFlowGuardService } from '../auth/guards/instantiate-flow-guard.service';
import { AuthModule } from '../auth/auth.module';
import { ReadOnlyFlowComponent } from './components/flow/read-only-flow/read-only-flow.component';
import { OnBehalfFlowComponent } from './components/on-behalf-flow/on-behalf-flow.component';
import { ClarificationNotesComponent } from './components/on-behalf-flow/clarification-notes/clarification-notes.component';
//import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReadOnlyOnBehalfComponent } from './components/on-behalf-flow/read-only-on-behalf/read-only-on-behalf.component';

@NgModule({
    imports: [
        AuthModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LunaCommonModule,
        ReactiveFormsModule,
        FormControlsModule,
        //PdfViewerModule
        NgxExtendedPdfViewerModule
    ],
    declarations: [
        FlowComponent,
        FlowSectionsComponent,
        ReadOnlyFlowComponent,
        OnBehalfFlowComponent,
        ClarificationNotesComponent,
        ReadOnlyOnBehalfComponent
    ],
    providers: [
        RuleCompiler,
        FunctionsFactory,
        { provide: Mapper, useClass: Mapper },
        FlowInstanceService,
        WorkflowResolver,
        InstantiateFlowGuardService,
        FlowHistoryService,
        OnBehalfMapperService
    ]
})
export class LunaFlowModule { }
